import img1 from "../../img/img1.jpeg";
import img2 from "../../img/img2.jpg";
import img3 from "../../img/img3.jpg";
import img4 from "../../img/img4.jpg";
import img5 from "../../img/img5.jpg";
import profile1 from "../../img/profile1.jpg";
import profile2 from "../../img/profile2.jpg";
import profile3 from "../../img/profile3.jpg";

const Completedapi = [
  //   {
  //     imgsrc: img1,
  //     title: "Full Stack developer",
  //     profile: profile1,
  //     name: "Olivia Wilson",
  //   },
  //   {
  //     imgsrc: img2,
  //     title: "Frontend Developer",
  //     profile: profile2,
  //     name: "Jonathan Pat",
  //   },
  //   {
  //     imgsrc: img3,
  //     title: "Backend Developer",
  //     profile: profile3,
  //     name: "Taeho ng",
  //   },
  {
    imgsrc: img4,
    title: "Data Analysis",
    profile: profile1,
    name: "Olivia Wilson",
  },
  {
    imgsrc: img5,
    title: "AWS",
    profile: profile2,
    name: "Jonathan Pat",
  },
  // {
  //   imgsrc: img1,
  //   title: "UI/UX Design",
  //   profile: profile3,
  //   name: "Taeho ng",
  // },
  // {
  //   imgsrc: img2,
  //   title: "Full Stack developer",
  //   profile: profile1,
  //   name: "Olivia Wilson",
  // },
  // {
  //   imgsrc: img3,
  //   title: "Frontend Developer",
  //   profile: profile2,
  //   name: "Jonathan Pat",
  // },
  // {
  //   imgsrc: img4,
  //   title: "Backend Developer",
  //   profile: profile3,
  //   name: "Taeho ng",
  // },
  // {
  //   imgsrc: img5,
  //   title: "Data Analysis",
  //   profile: profile1,
  //   name: "Olivia Wilson",
  // },
  // {
  //   imgsrc: img1,
  //   title: "AWS",
  //   profile: profile2,
  //   name: "Jonathan Pat",
  // },
  // {
  //   imgsrc: img2,
  //   title: "UI/UX Design",
  //   profile: profile3,
  //   name: "Taeho ng",
  // },
];

export default Completedapi;
